<template>
  <v-menu rounded="0" transition="slide-x-transition" bottom left>
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        small
        tile
        elevation="0"
        class="ma-0 text-capitalize btn-account"
        v-bind="attrs"
        v-on="on"
      >
        Add New
        <v-icon right>
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-card class="dropdown-menu-card" tile flat>
      <v-list flat outlined>
        <v-list-item-group>
          <v-list-item v-for="(item, i) in items" :key="i" :ripple="false">
            <v-list-item-content>
              <router-link
                v-text="item.text"
                class="text-decoration-none"
                router
                :to="item.link"
              ></router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        text: "Bank",
        link: "/add-bank-account",
      },
      {
        text: "Crypto",
        link: "/add-crypto-account",
      },
      
    ],
  }),
};
</script>

<style scoped>
.dropdown-menu-card {
  border: 1px solid #d99a00;
  border-radius: 6px !important;
}
.dropdown-menu-card .v-list { padding: 4px; }
.dropdown-menu-card .v-list-item { min-height: 40px; }
.dropdown-menu-card a { color: inherit !important; }
.theme--dark.dropdown-menu-card,
.theme--dark .dropdown-menu-card { border-color: #ffc400; background: #07111b !important; }
</style>
